import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export {
  GetAllEditions,
  GetSinlgeEdition,
  SaveEditionInformation,
  CloneEdition,
  SetEditionInactive,
  PublishEdition,
  DeleteEdition,
  GetGavServiceUrl,
  GetUniaServiceUrl,
  CheckPublicationRequirements,
  CheckMlChanges,
  GetMinimumSalaryConfigurations
};

function GetAllEditions(contractNumber, versionNumber, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions`,
      headers
    )
    .then(response => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response.data);
      }
    })
    .catch(error => {
      onError(error);
    });
}

function GetGavServiceUrl(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/infrastructure/serviceurl/gavservice/de-CH`,
      headers
    )
    .then(response => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response.data);
      }
    })
    .catch(error => {
      onError(error);
    });
}

function GetUniaServiceUrl(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/infrastructure/serviceurl/uniaservice/de-CH`,
      headers
    )
    .then(response => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response.data);
      }
    })
    .catch(error => {
      onError(error);
    });
}

function GetSinlgeEdition(
  contractNumber,
  versionNumber,
  editionNumber,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}`,
      headers
    )
    .then(response => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response.data);
      }
    })
    .catch(error => {
      onError(error);
    });
}

function SaveEditionInformation(
  editionInformation,
  contractId,
  versionId,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/editions`,
      editionInformation,
      headers
    )
    .then(response => {
      if (response.data && response.data.httpResultCode == 500) {
        onError(response);
      } else {
        onSuccess(response.data);
      }
    })
    .catch(error => {
      onError(error);
    });
}

function CloneEdition(
  contractId,
  versionId,
  editionToClone,
  copyMindestlohn,
  importData,
  onSuccess,
  onError
) {
  // this endpoint needs some explanation
  // the contract ID is ignored completly
  // the versionid is the Id (not the Number) of the Version where the cloned edition will be copied to
  // the editionToClone is the ID of the edition that will be cloned. It doesnt event necessatily needs to be in the same
  // contract as the version its being copied into

  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/editions/${editionToClone}/clone?copyMindestlohn=${copyMindestlohn}`,
      importData != undefined ? importData : null,
      headers
    )
    .then(response => {
      onSuccess(response);
    })
    .catch(error => {
      onError(error);
    });
}

function PublishEdition(
  contractNumber,
  versionNumber,
  editionId,
  mlChanged,
  klauselnChanged,
  onSuccess,
  onError
) {
  const headers = getAuthHeader();

  // Build query string safely so that a missing first param does not break URL
  const params = [];
  if (mlChanged === true) params.push("mlChanged=true");
  if (klauselnChanged === true) params.push("klauselnChanged=true");
  const query = params.length ? `?${params.join("&")}` : "";

  axios
    .post(
      `${process.env.VUE_APP_BASE_API_URL}/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/aktualisieren${query}`,
      null,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch(error => {
      onError(error);
    });
}

function CheckPublicationRequirements(
  contractNumber,
  versionNumber,
  editionId,
  editionState,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  var publishedState = editionState;

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/checkpublishconditions/${publishedState}`,
      headers
    )
    .then(results => {
      onSuccess(results.data);
    })
    .catch(error => {
      onError(error);
    });
}

function CheckMlChanges(
  contractNumber,
  versionNumber,
  editionId,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/checkpublishmlchanges`,
      headers
    )
    .then(results => {
      onSuccess(results.data);
    })
    .catch(error => {
      onError(error);
    });
}

function SetEditionInactive(
  contractNumber,
  versionNumber,
  editionId,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  var inactiveState = 5;

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/editionstates/${inactiveState}`,
      null,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch(error => {
      onError(error);
    });
}

function DeleteEdition(contractId, versionId, editionId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/editions/${editionId}`,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch(error => {
      onError(error);
    });
}

function GetMinimumSalaryConfigurations(
  contractNumber,
  versionNumber,
  editionId,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/mindestlohn/configuration`,
      null,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch(error => {
      onError(error);
    });
}
